import { render, staticRenderFns } from "./list.vue?vue&type=template&id=a047b7d8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"
import style0 from "./list.vue?vue&type=style&index=0&id=a047b7d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a047b7d8",
  null
  
)

export default component.exports